// SecretaryDashboard.js
import Navbar from "../../components/Navbar";

const SecretaryDashboard = () => (
  <div>
    <Navbar />
    <div style={{ textAlign: "center", marginTop: "80px" }}>
      <h1>Welcome, Secretary!</h1>
      <p>Manage players, events, and approvals from your dashboard.</p>
    </div>
  </div>
);

export default SecretaryDashboard;
